import React from "react";
const icon = (
  <svg
    width="512"
    height="512"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2_62)">
      <path
        d="M432 48H208C190.3 48 176 62.3 176 80V96H128V80C128 35.8 163.8 0 208 0H432C476.2 0 512 35.8 512 80V304C512 348.2 476.2 384 432 384H416V336H432C449.7 336 464 321.7 464 304V80C464 62.3 449.7 48 432 48ZM48 448C48 456.8 55.2 464 64 464H320C328.8 464 336 456.8 336 448V256H48V448ZM64 128H320C355.3 128 384 156.7 384 192V448C384 483.3 355.3 512 320 512H64C28.7 512 0 483.3 0 448V192C0 156.7 28.7 128 64 128Z"
        fill="#8803E9"
      />
    </g>
    <defs>
      <clipPath id="clip0_2_62">
        <rect width="512" height="512" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default icon;
